<template>
    <div :class="classes" @click.self="isClickable ? $emit('onClickLinkedObject') : null">
        <div class="activity-linked-object__text">
            <span
                class="typographies-paragraph-small-bold activity-linked-object__text-introduction"
                @click.self="isClickable ? $emit('onClickLinkedObject') : null"
                >{{ introductionLabel }}</span
            >
            <CompassIcon :icon="icon" size="small" />
            <CompassTooltip
                :disabled="!shouldDisplayTooltip"
                :content="name"
                placement="top"
                :arrow="false"
            >
                <CompassLink
                    ref="compassLink"
                    target="_blank"
                    :link="link"
                    :label="name"
                    size="small"
                    type="secondary"
                />
            </CompassTooltip>
        </div>
        <CompassTooltip
            v-if="isRemovable"
            :content="$t.__('common.actions.delete_link')"
            :arrow="false"
        >
            <CompassIconButton icon="close" size="small" @click="$emit('remove')" />
        </CompassTooltip>
    </div>
</template>

<script>
export default {
    props: {
        object: {
            type: String,
            required: true,
        },
        isRemovable: {
            type: Boolean,
            default: false,
        },
        introduction: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        showSpacing: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
            default: '',
        },
        isClickable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            shouldDisplayTooltip: false,
        };
    },
    computed: {
        introductionLabel() {
            return (
                this.introduction ||
                this.$t.__('activity.ActivityLinkedObject.introduction_default')
            );
        },
        classes() {
            return [
                'activity-linked-object',
                this.showSpacing ? 'activity-linked-object--spacing' : '',
                this.isClickable ? 'activity-linked-object--clickable' : '',
            ];
        },
        icon() {
            return `obj-slsy-${this.object}`;
        },
    },
    mounted() {
        const compassLinkLabel = this.$refs.compassLink?.$el.querySelector('.compass-link__label');
        let textIsEllipsed = false;
        if (compassLinkLabel) {
            //We check height because we limit text to one line and ellipsis it
            textIsEllipsed = compassLinkLabel.clientHeight < compassLinkLabel.scrollHeight;
        }
        this.shouldDisplayTooltip = !!this.name && textIsEllipsed;
    },
};
</script>

<style scoped lang="scss">
.activity-linked-object {
    align-items: center;
    border: 1px solid var(--colors-common-border-lighter);
    border-radius: var(--spacing-0);
    display: flex;
    flex-direction: row;
    gap: var(--spacing-1);
    justify-content: space-between;
    padding: var(--spacing-1);

    &--clickable {
        cursor: pointer;

        &:hover {
            background-color: var(--colors-common-background-hover);
        }
    }

    &__text {
        align-items: center;
        display: flex;
        flex-direction: row;
        gap: var(--spacing-0);

        &-introduction {
            flex-shrink: 0;
        }
        :deep() {
            .compass-link__label {
                -webkit-box-orient: vertical;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
            }

            .compass-icon {
                flex-shrink: 0;
            }
        }
    }

    &--spacing {
        margin-bottom: var(--spacing-2);
    }
}
</style>
